module.exports = __webpack_public_path__ + "static/img/user.4f339cbe.png";